import { render, staticRenderFns } from "./PurchaseFilters.view.vue?vue&type=template&id=1ff4a44a&"
import script from "./PurchaseFilters.view.vue?vue&type=script&lang=js&"
export * from "./PurchaseFilters.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff4a44a')) {
      api.createRecord('1ff4a44a', component.options)
    } else {
      api.reload('1ff4a44a', component.options)
    }
    module.hot.accept("./PurchaseFilters.view.vue?vue&type=template&id=1ff4a44a&", function () {
      api.rerender('1ff4a44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/list/partials/PurchaseFilters.view.vue"
export default component.exports